import { useState } from "react";
import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Loader } from "@/components/shared/loader";
import { cn } from "@/lib/utils";
import { useDeactivateUser } from "@/features/users/hooks/useUsersMutations";

interface DeactivateUserDialogProps {
  userId: string;
  isActive: boolean;
}

export function DeactivateUserDialog({
  userId,
  isActive,
}: DeactivateUserDialogProps) {
  const [open, setOpen] = useState(false);
  const { mutateAsync, isPending } = useDeactivateUser();

  if (!isActive) {
    return null;
  }

  const handleDeactivate = async () => {
    try {
      await mutateAsync(userId);
      setOpen(false);
    } catch {
      /* useDeactivateUser.onError handles errors */
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center text-gray-600 hover:text-red-600 transition-colors"
          aria-label="تعطيل المستخدم"
          title="تعطيل المستخدم"
        >
          <Ban className={cn("h-4", "w-4")} />
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-right">
          <DialogTitle>تعطيل المستخدم</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600 text-right mb-4">
          هل أنت متأكد من تعطيل هذا المستخدم؟ لن يتمكن من تسجيل الدخول حتى يتم
          تفعيله مجدداً.
        </p>
        <Button
          type="button"
          variant="destructive"
          disabled={isPending}
          onClick={handleDeactivate}
          className="w-full"
        >
          تعطيل المستخدم
          {isPending && <Loader className="mr-2" />}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
